import styled, { css } from 'styled-components';

export default styled.button`
  ${() => {
    return css`
      background: var(--primary-color);
      border: 0.125em solid var(--color-midnight-lighter);
      border-radius: 0.188em;
      width: 2em;
      height: 2em;
      padding: 0;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      position: relative;
      &:hover,
      &:focus,
      &:active {
        svg path {
          fill: var(--color-white);
        }
      }
      &:hover {
        background: var(--color-midnight-dark);
        border: 0.125em solid var(--color-midnight-lightest);
        .icon-button__tooltip {
          display: block;
        }
      }
      &:active {
        background: var(--color-midnight);
        border: 0.125em solid var(--color-midnight-lightest);
      }
      &:focus {
        background: var(--primary-color);
        border: 0.125em solid var(--color-midnight-lighter);
        box-shadow: none !important;
        outline: none !important;
        .focus-ring {
          border: 0.125em solid var(--a11y);
          border-radius: 0.375em;
        }
      }
      .focus-ring {
        position: absolute;
        width: 2.25em;
        height: 2.25em;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
      .icon-button__tooltip {
        position: absolute;
        right: 2.375em;
        top: 50%;
        transform: translateY(-50%);
        max-width: fit-content;
        white-space: nowrap;
        height: fit-content;
        display: none;
      }
      &[data-variant='secondary'] {
        background: transparent;
        border-color: transparent;
        &:hover {
          background: var(--color-neutral-20);
          border: 0.125em solid var(--color-neutral-40);
          border-radius: 0.188em;
          svg path {
            fill: var(--primary-color);
          }
        }
        &:focus {
          background: var(--color-white);
          border: 0.125em solid var(--color-white);
          border-radius: 0.188em;
          svg path {
            fill: var(--primary-color);
          }
        }
      }
      &[data-variant='tertiary'] {
        border: none;
      }
    `;
  }}
`;
